module.exports = __webpack_public_path__ + "static/img/ycks3.4fe0d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/appopen/appopen/ycks3.png
// module id = Etsw
// module chunks = 0